import { render, staticRenderFns } from "./FuWuQiBiaoZhun.vue?vue&type=template&id=969f3b64&scoped=true&"
import script from "./FuWuQiBiaoZhun.vue?vue&type=script&lang=js&"
export * from "./FuWuQiBiaoZhun.vue?vue&type=script&lang=js&"
import style0 from "./FuWuQiBiaoZhun.vue?vue&type=style&index=0&id=969f3b64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969f3b64",
  null
  
)

export default component.exports